import React from 'react'
import AltNav from '../components/AltNav.js';

const BetweenChoirs = () => {
    return (
        <div>
            <AltNav />
            <div className='work-alt-header-bg'></div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className='work-page-main'>
                <div className='blue-glow projects-header'>
                    <div className='gb-inner gb-inner-img' style={{ backgroundImage: `url('portfolio-images/between-choirs.jpg')` }}>
                        <div class="glow-wrapper">
                            <span class="glow-text">BETWEEN CHOIRS</span>
                            <span class="stroke-text">BETWEEN CHOIRS</span>
                        </div>

                        <h2>EDUTAINMENT APP</h2>
                    </div>
                </div>


                <br />
                <br />

                <div className='overview'>
                    <div className='ov1'>
                        <h2>Overview</h2>

                        <p>Entertainment App I built for Scholatship Auditions as a freelancer.</p>

                        <ul>
                            <li>Built with React</li>
                            <li>Was used at Show Choir Events all across the Nation.</li>
                            <li>We refer to it as an Edutainment app, Education + Entertainment. Designed for audience members</li>
                            <li>On the Educational Side the app features many articles</li>
                            <li>For Entertainment the app features games such as a trivia game, a themed tic tac toe game, and a crossword puzzle</li>
                            <li>It features other activities including an online coloring book with several templates, and a scavenger hunt game</li>
                            <li>I developed all of these games and activities myself</li>
                            <li>Feel free to play through them</li>
                        </ul>
                        <a href='https://betweenchoirs.com/' target='_blank'>
                            <button className='glow-box-btn ovbtn'>
                                View Site
                            </button>
                        </a>

                    </div>
                    <div className='ov2'>
                        <div className='pink-glow'>
                            <div className='pg-inner'>
                                <img src='portfolio-images/bc-1.jpg' alt='Eventure Desktop View' />
                            </div>

                        </div>

                    </div>
                </div>
                <br />
                <br />




                <div className='pink-glow'>
                    <div className='pg-inner project-summary'>
                        <h3 className='summary'>Summary</h3>
                        <p>Between Choirs is a web-based engagement platform designed to connect, entertain, and inform participants at choir festivals and competitions. Created as a passion project, the site features interactive games, announcements, and event details tailored to enhance the downtime experience between performances. With a mobile-first design, bold visuals, and a playful interface, Between Choirs brings a sense of community and energy to an often overlooked aspect of the choral experience — the waiting. The project showcases my full-stack capabilities, from user-friendly front-end interactions to efficient content management behind the scenes.</p>
                    </div>
                </div>

                <br />
                <br />







            </div>

        </div>
    )
}

export default BetweenChoirs